var current_fs, next_fs, previous_fs; //fieldsets
var left, opacity, scale; //fieldset properties which we will animate
var animating; //flag to prevent quick multi-click glitches
$(".item-individual select.doggy-food-w-variant").addClass("active");

$(".next").click(function(){
	if(animating) return false;
	animating = false;
	
	current_fs = $(this).parents("section.subscription-step");
	next_fs = $(this).parents("section.subscription-step").next();
	
	//activate next step on progressbar using the index of next_fs
	//$("#stepbar li").eq($(".subscription-step").index(next_fs)).addClass("active");
	next_fs.addClass("active");
    current_fs.removeClass("active");
	//show the next fieldset
	next_fs.css("display","flex");
	//hide the current fieldset with style
	current_fs.animate({opacity: 0}, {
		step: function(now, mx) {
			//as the opacity of current_fs reduces to 0 - stored in "now"
			//1. scale current_fs down to 80%
			scale = 1 - (1 - now) * 0.2;
			//2. bring next_fs from the right(50%)
			left = (now * 50)+"%";
			//3. increase opacity of next_fs to 1 as it moves in
			opacity = 1 - now;
			current_fs.css({
       // 'transform': 'scale('+scale+')',
        'position': 'relative'
      });
			next_fs.css({'left': left, 'opacity': opacity});
		}, 
		duration: 10, 
		complete: function(){
			current_fs.hide();
			animating = false;
		}
	});
});

$(".previous").click(function(){
	if(animating) return false;
	animating = false;
	
	current_fs = $(this).parents("section.subscription-step");
	previous_fs = $(this).parents("section.subscription-step").prev();
	
	//de-activate current step on progressbar
	//$("#stepbar li").eq($(".subscription-step").index(current_fs)).removeClass("active");
	
	//show the previous fieldset
	previous_fs.show(); 
	//hide the current fieldset with style
	current_fs.animate({opacity: 0}, {
		step: function(now, mx) {
			//as the opacity of current_fs reduces to 0 - stored in "now"
			//1. scale previous_fs from 80% to 100%
			scale = 0.8 + (1 - now) * 0.2;
			//2. take current_fs to the right(50%) - from 0%
			left = ((1-now) * 50)+"%";
			//3. increase opacity of previous_fs to 1 as it moves in
			opacity = 1 - now;
			current_fs.css({'left': left});
			previous_fs.css({
            //  'transform': 'scale('+scale+')', 
              'opacity': opacity});
          previous_fs.addClass("active");
          current_fs.removeClass("active");
		}, 
		duration: 10, 
		complete: function(){
			current_fs.hide();
			animating = false;
		}
	});
});

function updateFoodIngredients() {
  var food_items = $(".recipe-item").find("input.ingredient-selector:checked").map(function() {
    return this.value;
  }).get().join(", ");
  $(".food-ingredients").text(food_items);

  const allergyCheckboxess = $('.ingredient-selector');
  const ingredientVariantCheckboxes = $('input.variant-selection');
  const selectedAllergiess = allergyCheckboxess.filter(':checked').map(function() {
      return $(this).val().toLowerCase();
  }).get();
  ingredientVariantCheckboxes.each(function() {
      const ingredientVariants = $(this).data("flavor").toLowerCase();
      if (selectedAllergiess.includes(ingredientVariants)) {
          $(this).prop('checked', true);
      } else {
          $(this).prop('checked', false);
      }
  });
}

$(".ingredient-selector").change(function() {
  updateFoodIngredients();
   DistributeVariantsQuantity();
})

$("span.more-details").click(function() {
  if (window.innerWidth <= 768) { // Adjust the width as per your breakpoint for mobile
    $(this).nextAll(".product-content-popup").first().removeClass("hidden");
  } else {
    $(this).nextAll(".product-desktop-container").first().removeClass("hidden");
  }
})

$(".close-button").click(function() {
  $(this).parents(".product-content-popup").addClass("hidden");
})
$(".close-buttonn").click(function() {
  $(this).parents(".product-desktop-container").addClass("hidden");
})


let bagsToSend = 0;
let discount_divider = 100 / (100 - discountt);
let discount_divider_saving = 100 / discountt;
console.log(discountt, discount_divider, discount_divider_saving)

// Function to calculate the total weight and number of bags needed
function calculateBags() {
  const gramsValue = parseInt($('.gramos-value').text());
  const daysValue = parseInt($('.frequency-option').attr('data-days'));
  const totalWeight = gramsValue * daysValue;
  const bagWeight = 500;
  const bagsNeeded = Math.ceil(totalWeight / bagWeight);
  bagsToSend = bagsNeeded;
  $('.bagsToSend').text(bagsToSend);
  let price = (bagsToSend * $(".item-atc-button").parent().find("select.doggy-food-w-variant.active option:selected").data("price")) / (daysValue * 100);
  let price_per_day_flexible = price.toFixed(2);
  $('.price-per-day-flexible').text(price_per_day_flexible);
  let price_per_day_discounted = (price*7).toFixed(2);
  $('.price-per-day-discounted').text(price_per_day_discounted);
  let ppprice = $(".item-atc-button").parent().find("select.doggy-food-w-variant.active option:selected").data("price") / (daysValue * 100);
  $(".product-price-fixed").text((bagsToSend * ppprice * daysValue).toFixed(2));
  let subscription_price_discounted = $(".item-atc-button").parent().find("select.doggy-food-w-variant.active option:selected").data("price") / (daysValue * 100 * discount_divider_saving);
  $('.discount-final').text((bagsToSend * subscription_price_discounted * daysValue).toFixed(2));
  console.log(bagsToSend, bagWeight, price);
}

function calculateRecommendedPrice() {
  const gramsValue = parseInt($('.gramos-value').text());
  const daysValue = parseInt($('.frequency-option').attr('data-days'));
  const totalWeight = gramsValue * daysValue;
  const bagWeight = 500;
  var p_price = $(".item-atc-button").parent().find("select.doggy-food-w-variant.active option:selected").data("price");
  let price = (bagsToSend * p_price) / (daysValue * 100);
  let price_per_day = (price / discount_divider).toFixed(2);
  $('.price-per-day').text(price_per_day);
}

// For managing the frequencies

$(document).ready(function() {
  const options = [];
  let defaultIndex = 0;
  $('.selling-name label').each(function(index) {
    const optionText = $(this).text().trim();
    const weeks = parseInt(optionText) || 0;
    if (optionText !== "One-time purchase") {
      options.push({
        text: optionText,
        value: $(this).data('value'),
        days: weeks * 7,
        price: bagsToSend * $(this).data('price'),
      });
      if (weeks === 4) {
        defaultIndex = index - 1;
      }
    }
  });

  let currentIndex = defaultIndex;
  const totalOptions = options.length;

  function updateFrequencyOption() {
    const currentOption = options[currentIndex];
    $('.frequency-option').text(currentOption.text).attr('data-value', currentOption.value).attr('data-days', currentOption.days).attr('data-price', currentOption.price);
    $(`.selling-plan input[type=radio]`).prop('checked', false);
    $(`.selling-plan input[type=radio][value=${currentOption.value}]`).prop('checked', true);
    calculateBags();
    $(".delivery-frequency-text").text(currentOption.text);
    $(".frequency-number").text(currentOption.days / 7);
    $('input.variant-selection').attr('data-selling_id', currentOption.value);
  }

  $('.frequency-arrow-left').click(function() {
    currentIndex = (currentIndex - 1 + totalOptions) % totalOptions;
    updateFrequencyOption();
    DistributeVariantsQuantity();
  });

  $('.frequency-arrow-right').click(function() {
    currentIndex = (currentIndex + 1) % totalOptions;
    updateFrequencyOption();
    DistributeVariantsQuantity();
  });

  updateFrequencyOption(); // Initialize with the first option

$("input[name=payment-selector]").change(function() {
  var payment_mode = $(this).val();
  if (payment_mode == "manual") {
    $(".frequency-option").attr("data-value", "");
  } else {
    updateFrequencyOption();
  }
})

$(document).ready(function() {
  if($("input[name=payment-selectorr]").is(":checked")) {
    $(".cart.next").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".cart.next").find("button").removeAttr("disabled");
  } else {
    $(".cart.next").addClass("stickynavigation-module__disabled___1GDwt");
    $(".cart.next").find("button").attr("disabled");
  }
})
$("input[name=payment-selectorr]").change(function() {
  var payment_modee = $(this).val();
  if (payment_modee == "manual") {
    $(".frequency-option").attr("data-value", "");
  } else {
    updateFrequencyOption();
  }
    $(".cart.next").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".cart.next").find("button").removeAttr("disabled");
})

$(".restart-quiz").click(function() {
  window.location.href = '/pages/subscribe';
})


$('.minus-quantity').click(function() {
  var currentValue = parseInt($('.gramos-value').text());
  if (currentValue > 50) {
    $('.gramos-value').text((currentValue - 50) + 'g');
    calculateBags();
    DistributeVariantsQuantity();
  }
});

$('.plus-quantity').click(function() {
  var currentValue = parseInt($('.gramos-value').text());
  $('.gramos-value').text((currentValue + 50) + 'g');
  calculateBags();
  DistributeVariantsQuantity();
});

function DistributeVariantsQuantity() {
  console.log(bagsToSend);
  var checkedInputs = $('input.variant-selection:checked');
  var count = checkedInputs.length;

  if (count > 0) {
    var bagsPerInput = Math.floor(bagsToSend / count);
    var remainder = bagsToSend % count; 

    checkedInputs.each(function(index) {
      var quantity = bagsPerInput + (index < remainder ? 1 : 0);
      $(this).data("quantity", quantity);
    });
  } else {
    $('input.variant-selection').data("quantity", '');
  }
}

$(".clear-cart-button").click(function() {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/clear.js',
    dataType: 'json',
    success: function() {
      console.log('Cleared the cart.');
    },
    error: function() {
      alert('Failed to clear the cart. Please try again.');
    }
  });
})
  
$(".cart-button").click(function() {
  $(".modal").show();
  let items = [];
  var variant_id = $(".item-atc-button").parent().find("select.doggy-food-w-variant.active").val();
  var qty = bagsToSend;
  var selling_plan = $(".frequency-option").data("value");
  var frequency = $(".frequency-option").text();
  var payment_mode = $("input[name=payment-selectorr]:checked").val();
  var line_item = $(".recipe-item").find("input.ingredient-selector:checked").map(function() {
    return this.value;
  }).get().join(", ");
  // var line_item_properties = {
  //   "Alimentos": line_item,
  //   "Resumen": qty +" paquetes de 500gr",
  // };
  // if (payment_mode == "manual") {
  //   line_item_properties["Frecuencia"] = frequency;
  // }

  $('input.variant-selection:checked').each(function() {
    let quantity = parseInt($(this).data("quantity"));
    let variantId = $(this).val();
    var line_item_properties = {
      "Resumen": quantity +" paquetes de 500gr",
    };
    if (payment_mode == "manual") {
      line_item_properties["Frecuencia"] = frequency;
    }
    
    if (quantity > 0) {
      items.push({
        id: variantId,
        quantity: quantity,
        selling_plan: selling_plan,
        properties: line_item_properties
      });
    }
  });

  // const address1 = $('input[name="address1"]').val();
  // const address2 = $('input[name="address2"]').val();
  // const city = $('input[name="city"]').val();
  // const country = $('input[name="country"]').val();
  // const zip = $('input[name="zip"]').val();
 
  // let checkoutUrl = `/cart?checkout[shipping_address][address1]=${encodeURIComponent(address1)}&checkout[shipping_address][city]=${encodeURIComponent(city)}&checkout[shipping_address][country]=${encodeURIComponent(country)}&checkout[shipping_address][zip]=${encodeURIComponent(zip)}&checkout[shipping_address][address2]=${encodeURIComponent(address2)}&`;
  // console.log(checkoutUrl);

  let checkoutUrl = $("form#cart").attr('action');
  checkoutUrl = checkoutUrl.replace('/cart/', '/checkout/');
  console.log(checkoutUrl)

  let data = {
    items: items
  };
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify(data),
    contentType: 'application/json',
    dataType: 'json',
    success: function() { 
      // window.location.href = '/checkout?discount=SHIPFREE'; 
      window.location.href = checkoutUrl+'discount=SHIPFREE'; 
    }
  });

  
  // Clear the cart first
  // 14 Feb 2025
  // jQuery.ajax({
  //   type: 'POST',
  //   url: '/cart/clear.js',
  //   dataType: 'json',
  //   success: function() { 
  //     // After clearing the cart, add the new product
  //     let data = {
  //       items: items
  //     };
  //     jQuery.ajax({
  //       type: 'POST',
  //       url: '/cart/add.js',
  //       data: JSON.stringify(data),
  //       contentType: 'application/json',
  //       dataType: 'json',
  //       success: function() { 
  //         // window.location.href = '/checkout?discount=SHIPFREE'; 
  //         window.location.href = checkoutUrl+'discount=SHIPFREE'; 
  //       }
  //     });
  //   },
  //   error: function() {
  //     alert('Failed to clear the cart. Please try again.');
  //   }
  // });
  // 14 feb 2025
});

updateFoodIngredients();
DistributeVariantsQuantity();
});

$("button#confirm-button").on("click", function() {
  $(".map.next").removeClass("stickynavigation-module__disabled___1GDwt");
  $(".map.next").find("button").removeAttr("disabled");
})
$("button#change-location-button").on("click", function() {
  $(".map.next").addClass("stickynavigation-module__disabled___1GDwt");
  $(".map.next").find("button").attr("disabled","");
})
$(document).ready(function() {
var inputt = document.querySelector("input#petParentMobile");
var iti = intlTelInput(inputt, {
    initialCountry: "ve",
    separateDialCode: true,
    formatAsYouType: false,
    strictMode: true,
    utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/22.0.0/js/utils.js',
  });
  
var countryCode = '+' + iti.getSelectedCountryData().dialCode;
inputt.value = countryCode;
  
  inputt.addEventListener('input', function() {
    var number = iti.getNumber(intlTelInputUtils.numberFormat.E164);
    if(iti.isValidNumber()) {
      console.log('Valid number: ' + number);
      Cookies.set("dogOwnerMobile", number, { expires: 5 });
    } else {
      console.log('Invalid number');
    }
  });

// To dynamically set the full phone number with the country code as the user types or changes country
inputt.addEventListener('countrychange', function() {
    var dialCode = "+" + iti.getSelectedCountryData().dialCode;
    inputt.value = dialCode;
    Cookies.set('selectedDialCode', dialCode, { expires: 5 });
});

    var savedDialCode = Cookies.get('selectedDialCode');
    console.log("Saved code:" + savedDialCode)
    const countryData = intlTelInput.getCountryData();
    if (savedDialCode) {
        var matchingCountry = countryData.find(country => '+' + country.dialCode === savedDialCode);
        if (matchingCountry) {
            iti.setCountry(matchingCountry.iso2);
        }
    } else {
        var countryCode = '+' + iti.getSelectedCountryData().dialCode;
        console.log(countryCode);
        inputt.value = countryCode;
    }
     var OwnerMobile = Cookies.get("dogOwnerMobile");
     if (OwnerMobile) {
       $("#petParentMobile").val(Cookies.get("dogOwnerMobile"));
     }

  function updateButtonState() {
    var name = $('#petParentFullName').val();
    var email = $('#petParentEmail').val();
    var phone = iti.getNumber();
    var parent_id = $('#petParentId').val();
  
    // Check if all fields are filled and the phone number is valid
    if (name && email && parent_id) {
      $(".dog-account").removeClass("stickynavigation-module__disabled___1GDwt");
      $(".dog-account").find("button").removeAttr("disabled");
    } else {
      $(".dog-account").addClass("stickynavigation-module__disabled___1GDwt");
      $(".dog-account").find("button").attr("disabled","");
    }
  
    // Update cookies
    Cookies.set("dogOwnerName", name, { expires: 5 });
    Cookies.set("dogOwnerEmail", email, { expires: 5 });
    Cookies.set("dogOwnerId", parent_id, { expires: 5 });
}

$('#petParentFullName, #petParentEmail, #petParentMobile, #petParentId').on('input', updateButtonState);

inputt.addEventListener('countrychange', updateButtonState);

$('#petParentId').on('input', function() {
  $('#petParentPassword').val($(this).val());
});

$('#prefixDropdown').change(function() {
  Cookies.set("selectedPrefix", $(this).val(), { expires: 5 });
});

var selectedPrefix = Cookies.get("selectedPrefix");
if (selectedPrefix) {
 $("#prefixDropdown").val(Cookies.get("selectedPrefix"));
}

});

// jQuery(function() {
//   jQuery('#saveCustomer').click(function(event) {
//     event.preventDefault();
//     var data = jQuery(this).serialize();
//     var name = $('#petParentFullName').val();
//     var lastName = "";
//     var password;
//     var email = $('#petParentEmail').val();
//     var dogName = $('#dogNameInput-0').val();
//     var dogBreed = $('input.breed-input').val();
//     var dogAge = $('input.birth-date').val();
//     var dogNeutered = $('input[name=dog-0-desexed]:checked').val();
//     var dogWeight = $("input[name=weight]").val();
//     var dogShape = $('input[name=dog-body]:checked').val();
//     var dogActivity = $('input[name=dog-activity]:checked').val();
//     var prefix = $('#prefixDropdown').val();
//     var parent_id = $('#petParentId').val();
//     var escapedData = {
//       firstName: escape(name),
//       lastName: escape(lastName),
//       password: escape(password),
//       email: escape(email),
//       dogName: escape(dogName),
//       dogBreed: escape(dogBreed),
//       parent_id: escape(prefix + parent_id),
//       // dogAge: escape(dogAge),
//       dogNeutered: escape(dogNeutered),
//       dogWeight: escape(dogWeight),
//       dogShape: escape(dogShape),
//       dogActivity: escape(dogActivity),
//   }
//   var data = 'form_type=create_customer&utf8=%E2%9C%93&customer%5Bfirst_name%5D=';
//   data += escapedData.firstName;
//   data += '&customer%5Blast_name%5D=';
//   data += escapedData.lastName;
//   data += '&customer%5Bemail%5D=';
//   data += escapedData.email;
//   data += '&customer%5Bpassword%5D=';
//   data += escapedData.password;
//   data += '&customer%5Bnote%5D=' + JSON.stringify({
//         // dogName: escapedData.dogName,
//         // dogBreed: escapedData.dogBreed,
//         // dogAge: escapedData.dogAge,
//         // dogNeutered: escapedData.dogNeutered,
//         // dogWeight: escapedData.dogWeight,
//         // dogShape: escapedData.dogShape,
//         // dogActivity: escapedData.dogActivity,
//         parent_id: escapedData.parent_id,
//       });
    
//   jQuery.post('/account', data)
//   .done(function(response){
//     var logErrors = jQuery(response).find('.errors').text();
//     if (logErrors != '' && logErrors != 'undefined'){
//       console.log(logErrors);
//     }
//     else{
//       console.log('success!');
//     }
//   }).fail(function(){console.log('error could not submit');});
//   return false;
//   });
// });
jQuery('#create_customer').submit(function(event) {
    event.preventDefault();
});

// $(document).ready(function() {

// $(document).on('cf:customer_saved', function(e) {
//   e.preventDefault();
//   window.stop();
//   console.log('Customer data saved without reloading the page.');
//   return false;
// });
  
// $('#saveCustomer').click(function(e) {
//   e.preventDefault();
//   window.stop();
// var name = $('#petParentFullName').val();
// var email = $('#petParentEmail').val();
// // var phone = $('#petParentMobile').val();
// var password = $('#petParentPassword').val();
// var dog_name = $('#dogNameInput-0').val();
// var dog_breed = $('input.breed-input').val();
// // var dog_dob = $('input.birth-date').val();
// var dog_neutered = $('input[name=dog-0-desexed]:checked').val();
// var dog_weight = $("input[name=weight]").val();
// var dog_shape = $('input[name=dog-body]:checked').val();
// var dog_activity = $('input[name=dog-activity]:checked').val();
// var prefix = $('#prefixDropdown').val();
// var parent_id = $('#petParentId').val();
  
// var customerSaveOptions = {
//   login: true,
//   redirect: false,
//   formId: "70tGv7",
//   data: {
//     first_name: name,
//     email: email,
//     // phone: phone,
//     password: password,
//     parent_id: prefix + parent_id,
//     dog_name: dog_name,
//     dog_breed: dog_breed,
//     // dog_dob: dog_dob,
//     dog_neutered: dog_neutered,
//     dog_weight: dog_weight,
//     dog_shape: dog_shape,
//     dog_activity: dog_activity
//   }
// };

//   CF.customer.save(customerSaveOptions)
//     .then(function(errorObj) {
//       if (errorObj) {
//         // Handle errors
//         Object.keys(errorObj).forEach(function(key) {
//           console.log(key + ': ' + errorObj[key].join(', '));
//         });
//       } else {
//         window.stop();
//         console.log('Customer data saved successfully!');
        
        
//         login(email, password).done(function (html) {  
//           if (html.indexOf('Invalid login credentials') !== -1) {
//           } else {
//             var checkoutUrl = getCheckoutUrl();
//             if (checkoutUrl) {
//               window.location.href = checkoutUrl;
//             } else { 
//             }
            
//           }
//         });
        
//       }
//     })
//     .catch(function(err) {
//       // Error handling if the save method itself fails
//       console.error("Could not save customer", err);
//     });
// });
// });

jQuery(function() {
      jQuery('#signupForm').click(function(event) {
        // $('#saveCustomer').click();
        $('.loader').removeClass('hidden');
        
        setTimeout(function() {
        //   $('.loader').addClass('hidden');
        }, 500);
      });
    });

$(document).ready(function() {
var acc = document.getElementsByClassName("faq-question");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    $(this).next().toggleClass("faq-module__answerOpen___3cOdc");
    $(this).find(".faq-module__questionIcon___3yZjs").toggleClass("faq-module__questionIconOpen___1u_lf");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}  
})











// This is script adds content to modal just using same class


document.querySelectorAll('.link001').forEach(link => {
  link.addEventListener('click', function () {
    const card = this.closest('.card001');

    if (card) {
      const modalElement = document.getElementById('modal001');
      const modalContentElement = modalElement ? modalElement.querySelector('.modalcontent001') : null;

      if (!modalContentElement) {
        console.error("Modal content area not found! Ensure #modal001 contains .modalcontent001.");
        return;
      }

      // --- Configuration for content types ---
      // 1. Classes for plain text content (e.g., title, description)
      const textContentClasses = [
        'title001',
        'desc001',
        'price001', // Your price is text content
        'maxpro',    // Assuming maxpro is plain text
        'tester001', // Assuming tester is plain text
        'vtx',
         'dcx',
          'pqx',
         'badge001Q',
         'badge001A',
        'material001' // Assuming material is plain text
      ];

      // 2. Classes for innerHTML content (elements containing children, like badges)
      const innerHTMLClasses = ['badges001'];

      // 3. Classes for image elements (transferring 'src' and 'alt')
      const imageClasses = ['img001']; // Add any class here if it's on an <img> tag

      // --- START: Clearing previous content in the modal ---
      // Loop through all potential target elements in the modal and clear them
      // This is crucial to ensure clean content for each new product display.
      // Clear text content elements
      textContentClasses.forEach(className => {
          const targetEl = modalContentElement.querySelector(`.${className}`);
          if (targetEl) {
              targetEl.textContent = '';
          }
      });

      // Clear inner HTML elements
      innerHTMLClasses.forEach(className => {
          const targetEl = modalContentElement.querySelector(`.${className}`);
          if (targetEl) {
              targetEl.innerHTML = '';
          }
      });

      // Clear image elements (src and alt)
      imageClasses.forEach(className => {
          const targetEl = modalContentElement.querySelector(`img.${className}`); // Specific to IMG tag
          if (targetEl) {
              targetEl.src = '';
              targetEl.alt = '';
          }
      });
      // --- END: Clearing previous content ---


      // --- START: Transferring content from card to modal ---

      // 1. Transfer Plain Text Content
      textContentClasses.forEach(className => {
        const cardSourceElement = card.querySelector(`.${className}`);
        const modalTargetElement = modalContentElement.querySelector(`.${className}`);

        if (modalTargetElement && cardSourceElement) {
          modalTargetElement.textContent = cardSourceElement.textContent.trim();
        }
        // No 'else' needed here for clearing, as clearing is done upfront for all.
      });

      // 2. Transfer Inner HTML Content
      innerHTMLClasses.forEach(className => {
        const cardSourceElement = card.querySelector(`.${className}`);
        const modalTargetElement = modalContentElement.querySelector(`.${className}`);

        if (modalTargetElement && cardSourceElement) {
          modalTargetElement.innerHTML = cardSourceElement.innerHTML.trim();
        }
      });

      // 3. Transfer Image Source and Alt Attributes
      imageClasses.forEach(className => {
        const cardImageSource = card.querySelector(`img.${className}`); // Specific to IMG tag
        const modalImageTarget = modalContentElement.querySelector(`img.${className}`); // Specific to IMG tag

        if (modalImageTarget && cardImageSource && cardImageSource.src) {
          modalImageTarget.src = cardImageSource.src;
          modalImageTarget.alt = cardImageSource.alt || ''; // Transfer alt, default to empty
        }
      });
      // --- END: Transferring content ---


      // Finally, open the modal
      if (modalElement) {
        modalElement.style.display = 'flex';
      }
    } else {
      console.warn("Clicked link001, but no parent card001 found. Modal won't open for this trigger.");
    }
  });
});

// --- Modal close functions (no changes needed here) ---
function closeModal() {
  const modalElement = document.getElementById('modal001');
  if (modalElement) {
    modalElement.style.display = 'none';
  }
}

window.onclick = function (e) {
  const modalElement = document.getElementById('modal001');
  if (modalElement && e.target === modalElement) {
    closeModal();
  }
};










  function showCounter(btn) {
    const actionBox = btn.closest('.action001');
    actionBox.classList.add('show001');
  }

  function increment(btn) {
    const counter = btn.nextElementSibling;
    let count = parseInt(counter.textContent);
    counter.textContent = count + 1;
  }

  function decrement(btn) {
    const counter = btn.previousElementSibling;
    let count = parseInt(counter.textContent);
    if (count <= 1) {
      btn.closest('.action001').classList.remove('show001');
    } else {
      counter.textContent = count - 1;
    }
  }






        document.addEventListener('DOMContentLoaded', function() {
            const sections = document.querySelectorAll('.expandable-section');

            sections.forEach(section => {
                const header = section.querySelector('.expandable-header');

                // Make the "ANÁLISIS GARANTIZADO" section open by default
                if (section.id === 'analisis-garantizado') {
                    section.classList.add('open');
                }

                header.addEventListener('click', function() {
                    section.classList.toggle('open');
                });
            });
        });









